import { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { tenantApi } from "@/lib/api";
import { Loader2, CheckCircle2 } from "lucide-react";

/** Polls GET /api/v1/signup/:tenantId/status (contracts doc section 2)
 * until the tenant's provisioning saga completes. */
export default function SignupPending() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const tenantId = params.get("tenantId");
  const [status, setStatus] = useState("pending");

  useEffect(() => {
    if (!tenantId) return;
    let active = true;
    const poll = async () => {
      try {
        const res = await tenantApi.get(`/signup/${tenantId}/status`);
        if (!active) return;
        if (res.data.tenant_status === "ACTIVE") {
          setStatus("active");
          return;
        }
      } catch {
        // Transient failures during polling are not fatal — keep polling
        // on the existing interval rather than surfacing every blip.
      }
      if (active) setTimeout(poll, 2000);
    };
    poll();
    return () => {
      active = false;
    };
  }, [tenantId]);

  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-background">
      {status === "pending" ? (
        <>
          <Loader2 className="h-10 w-10 animate-spin text-primary" />
          <p className="text-muted-foreground">Setting up your workspace...</p>
        </>
      ) : (
        <>
          <CheckCircle2 className="h-10 w-10 text-emerald-600" />
          <p className="font-heading text-xl font-semibold">Your workspace is ready</p>
          <button className="text-sm font-medium text-primary" onClick={() => navigate("/login")} data-testid="signup-done-login-btn">
            Continue to sign in
          </button>
        </>
      )}
    </div>
  );
}
